import dayjs from 'dayjs'
import { useMemo } from 'react'
import { Trans } from '@lingui/macro'
import { Box, Typography, Stack, Grid, Card, CardContent } from '@mui/material'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import EventIcon from '@mui/icons-material/Event'

import { Planning } from '@/core/models/planning.model'
import { useLingui } from '@lingui/react'

export function StatisticCards({ plannings }: { plannings?: Planning[] }) {
  useLingui()

  const stats = useMemo(() => {
    if (!plannings) return { total: 0, active: 0, upcoming: 0, past: 0 }

    const now = dayjs()
    const total = plannings.length
    const active = plannings.filter((p) => dayjs(p.startDate).isBefore(now) && dayjs(p.endDate).isAfter(now)).length
    const upcoming = plannings.filter((p) => dayjs(p.startDate).isAfter(now)).length
    const past = plannings.filter((p) => dayjs(p.endDate).isBefore(now)).length

    return { total, active, upcoming, past }
  }, [plannings])

  return (
    <Box>
      <Grid container spacing={1} sx={{ mb: 1 }}>
        <Grid item xs={6}>
          <Card sx={{ height: '100%' }} variant="outlined">
            <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
              <Stack direction="row" spacing={0.5} alignItems="center">
                <CalendarMonthIcon color="primary" fontSize="small" />
                <Typography variant="body2">
                  <Trans>Total Plannings</Trans>
                </Typography>
              </Stack>
              <Typography variant="h6" align="right" color="primary.main">
                {stats.total}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6}>
          <Card sx={{ height: '100%' }} variant="outlined">
            <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
              <Stack direction="row" spacing={0.5} alignItems="center">
                <EventIcon color="success" fontSize="small" />
                <Typography variant="body2">
                  <Trans>Active</Trans>
                </Typography>
              </Stack>
              <Typography variant="h6" align="right" color="success.main">
                {stats.active}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6}>
          <Card sx={{ height: '100%' }} variant="outlined">
            <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
              <Stack direction="row" spacing={0.5} alignItems="center">
                <EventIcon color="info" fontSize="small" />
                <Typography variant="body2">
                  <Trans>Upcoming</Trans>
                </Typography>
              </Stack>
              <Typography variant="h6" align="right" color="info.main">
                {stats.upcoming}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6}>
          <Card sx={{ height: '100%' }} variant="outlined">
            <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
              <Stack direction="row" spacing={0.5} alignItems="center">
                <EventIcon color="action" fontSize="small" />
                <Typography variant="body2">
                  <Trans>Past</Trans>
                </Typography>
              </Stack>
              <Typography variant="h6" align="right" color="text.secondary">
                {stats.past}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}
